import React, { Component } from 'react';
import { Icon, Header, Segment } from 'semantic-ui-react'

export class Counter extends Component {
  static displayName = Counter.name;

  constructor(props) {
    super(props);
    this.state = { currentCount: 0 };
    this.incrementCounter = this.incrementCounter.bind(this);
  }

  incrementCounter() {
    this.setState({
      currentCount: this.state.currentCount + 1
    });
  }

  render() {
    return (
      <Segment placeholder>
        <Header icon>
            <Icon name='hashtag' />
            Counter
          </Header>
        <p aria-live="polite">Current count: <strong>{this.state.currentCount}</strong></p>
        <button className="btn btn-primary" onClick={this.incrementCounter}>Increment</button>
      </Segment>
    );
  }
}
